import Table from '@/common/components/Table'
import { Mapper } from '@/common/services/mapper'
import { cn } from '@/common/utils/cn'
import { useGovernmentAllocationSummary } from '@/features/governmentAllocations/hooks/useGovernmentAllocationSummary'
import {
  governmentAllocationSummaryCurrencyTableColumns,
  governmentAllocationSummaryQuantityTableColumns,
} from '@/features/governmentAllocations/pages/Show/constants/governmentAllocationSummaryTableColumns'
import { GovernmentAllocationSummaryTransformer } from '@/features/governmentAllocations/services/governmentAllocationSummaryTransformer'
import { GovernmentAllocationData } from '@/features/governmentAllocations/types/governmentAllocation.type'
import { GovernmentAllocationSummaryTableData } from '@/features/governmentAllocations/types/governmentAllocationSummary.type'

type GovernmentAllocationSummaryProps = {
  governmentAllocation: GovernmentAllocationData
}

export const GovernmentAllocationSummary = ({ governmentAllocation }: GovernmentAllocationSummaryProps) => {
  const { data: governmentAllocationSummary, isLoading: governmentAllocationSummaryIsLoading } =
    useGovernmentAllocationSummary<GovernmentAllocationSummaryTableData[]>({
      governmentAllocationId: governmentAllocation.id,
      mapper: Mapper.mapWithTransformer({
        transformer: GovernmentAllocationSummaryTransformer.tableTransformer(governmentAllocation.controlled_by),
      }),
    })

  return (
    <Table
      className={cn(
        'min-h-[256px]',
        governmentAllocation.controlled_by === 'quantity' ? 'max-h-[calc(100vh-432px)]' : 'max-h-[calc(100vh-496px)]',
      )}
      columns={
        governmentAllocation.controlled_by === 'currency'
          ? governmentAllocationSummaryCurrencyTableColumns
          : governmentAllocationSummaryQuantityTableColumns
      }
      rows={governmentAllocationSummary || []}
      stripedRows={false}
      page={1}
      totalPages={1}
      isLoadingData={governmentAllocationSummaryIsLoading}
    />
  )
}
